export default __webpack_public_path__ + "static/media/collections.c512fcf6.jpeg";